var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentDesigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4539_356406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30435 0H0V7.30435H7.30435V0Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 0H8.34783V7.30435H12.5217L15.6522 4.17391V0Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 11.4783L19.8261 8.34783H24V15.6522H16.6957V11.4783Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 8.34783H8.34783V11.4783L11.4783 8.34783Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 15.6522L15.6522 12.5217V15.6522H12.5217Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 19.8261L11.4783 16.6957H15.6522V24H8.34783V19.8261Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13043 16.6957L1.04348 22.9565L7.30435 20.8696V24H0V16.6957H3.13043Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30435 12.5217L4.17391 15.6522H0V8.34783H7.30435V12.5217Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 7.30435L24 4.17391V7.30435H20.8696Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 0L16.6957 3.13043V0H19.8261Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 0L24 4.17391V0H19.8261Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 16.6957H24V24H16.6957V16.6957Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.17391L19.8261 0L3.13041 16.6957L1.04346 22.9565L7.30433 20.8696L24 4.17391Z",
    fill: "#F7A246"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8261 0L24 4.17391L7.30435 20.8696L1.04348 22.9565L3.13043 16.6957L19.8261 0ZM18.2609 3.13043L19.8261 1.56522L22.4348 4.17391L20.8696 5.73913L18.2609 3.13043ZM19.8261 6.78261L17.2174 4.17391L5.21739 16.1739L7.82609 18.7826L19.8261 6.78261ZM4.17391 17.2174L6.78261 19.8261L4.17391 20.8696L3.13043 19.8261L4.17391 17.2174Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4539_356406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentDesigned);
export default __webpack_public_path__ + "static/media/Experiment_Designed.6dad1f6308b944048c9b2cf24f0d3138.svg";
export { ForwardRef as ReactComponent };